export function locationInManageMetaProductWorkflow(
	newPageUrl: string
): boolean {
	const regex =
		/\/masterorderguides\/\d+\/masteritems\/(\d+|new)\/(search|prioritize|addbyproductnumber)/;
	return regex.test(newPageUrl);
}

export function locationInNewMetaProductWorkflow(newPageUrl: string): boolean {
	const regex =
		/\/masterorderguides\/\d+\/masteritems\/(\d+|new)\/(newprioritize)/;
	return regex.test(newPageUrl);
}

export function locationInMetaProductPages(newPageUrl: string): boolean {
	const regex = /\/masterorderguides\/\d+\/masteritems/;
	return (
		regex.test(newPageUrl) || locationInManageMetaProductWorkflow(newPageUrl)
	);
}

export function routerWillLeaveNewMetaProductPage(
	newRoute,
	isMetaProductPageDirty: boolean
) {
	const newPageUrl = newRoute.pathname;
	if (!locationInNewMetaProductWorkflow(newPageUrl) && isMetaProductPageDirty) {
		return 'You have unsaved changes. Are you sure you want to leave?';
	}
}

export function onExceptionWorkflow(): boolean {
	return (
		window.location.pathname.startsWith('/exceptions') ||
		window.location.pathname.startsWith('/alerts')
	);
}

export function onAddMasterItemWorkflow(): boolean {
	return window.location.pathname.indexOf('/masteritems/new') > 0;
}

export function onAddDynamicMasterItemWorkflow(): boolean {
	return (
		onAddMasterItemWorkflow() &&
		window.location.href.indexOf('dynamic=true') > 0
	);
}
